<template>
  <div id="" ref="echart" :style="{height: chartHeight + 'px'}">
  </div>
</template>

<script>
export default {
  props: {
    chartData: {
      type: Object,
      default () {
        return {
          // xData: [],
          series: [],
          dimensions: [],
          chartlist: [],
          cnObj: {}
        }
      }
    },
    isAxisChart: {
      type: Boolean,
      default: true
    },
    chartHeight:{
      type: Number,
      default: 0
    }
  },
  watch: {
    chartData: {
        handler: function () {
            //newv,oldv
            this.initChart()
        },
        deep: true
    }
  },
  computed: {
    options () {
      return this.isAxisChart ? this.axisOption : this.normalOption
    }
  },
  methods: {
    initChart () {
      this.initChartData()
      // 设置chart表格
      if (this.echart) {
        if(this.oldzoomend!=0){
            //console.log(this.axisOption,this.oldzoomstart,this.oldzoomend)
            this.axisOption.dataZoom.start=this.oldzoomstart
            this.axisOption.dataZoom.end=this.oldzoomend
        }
        //这里true表示重新绘制，默认是false表示合并绘制
        this.echart.setOption(this.options,true)
      } else {
        this.echart = this.$echarts1.init(this.$refs.echart)
        this.echart.setOption(this.options)
      }
      let that =this
      this.echart.on('datazoom',function (params) {
          /*that.$nextTick(() => {
              console.log(that.echart.legend)
          })*/
          //console.log(params)
          that.oldzoomstart=params.start
          that.oldzoomend=params.end
          //console.log(that.oldzoomstart,that.oldzoomend)
      })
    },
    initChartData () {
      if (this.isAxisChart) {
          // this.axisOption.xAxis.data = this.chartData.xData
          this.axisOption.series=[]
          for(let i=0;i<this.chartData.dimensions.length;i++){
              if(this.chartData.dimensions[i]!='DNT'&&this.chartData.dimensions[i]!='dnt'){
                  if(this.chartData.dimensions[i].match(/[S|s]$/)){
                      this.axisOption.series.push({
                          name: this.chartData.cnObj[this.chartData.dimensions[i]],
                          type: "line",
                          yAxisIndex: 1
                      })
                  }else{
                      this.axisOption.series.push({
                          name: this.chartData.cnObj[this.chartData.dimensions[i]],
                          type: "line"
                      })
                  }
              }
          }
          /*this.axisOption.dataset.dimensions = this.chartData.dimensions
          this.axisOption.dataset.source = this.chartData.chartlist*/
          this.axisOption.dataset={
              dimensions: this.chartData.dimensions,
              source: this.chartData.chartlist
          }
      } else {
        this.normalOption.series = this.chartData.series
      }
    },
    /**
     * 重置echart
     **/
    echartResize: function () {
      let that=this
      setTimeout(function () {
        if (that.echart) {
          that.echart.resize()
        }
      }, 100);
    }
  },
  data () {
    return {
      axisOption: {
        legend: {
          top: "0%",
          left: "20px",
          textStyle: {
            color: '#333'
          },
          type: 'scroll'
        },
        grid: {
          left: '3%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          // data: [],
          axisLine: {
            lineStyle: {
              color: '#17b3a3'
            }
          },
          axisLabel: {
            // interval: 0,
            color: '#333'
          }
        },
        yAxis: [
          {
            type: 'value',
            splitNumber: 4,
            axisLine: {
              color: '#17b3a3'
            }
          },
          {
            type: 'value',
            splitNumber: 2,
            axisLine: {
              color: '#17b3a3'
            }
          }
        ],
        color: ['#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80', '#8d98b3'],
        series: [],
        dataset:{
          dimensions:[],
          source:[]
        },
       dataZoom:{
           //type:'inside',
           type:'slider',
           start:0,
           end:100,
           //startValue:30
        }
      },
      normalOption: {
        tooltip: {
          trigger: 'item'
        },
        color: [
          '#0f78f4',
          '#dd536b',
          '#9462e5',
          '#a6a6a6',
          '#e1bb22',
          '#39c362',
          '#3ed1c1'
        ],
        series: []
      },
      echart: null,
      oldzoomstart:0,
      oldzoomend:0
    }
  },
  created(){
    window.addEventListener('resize', this.echartResize)
  }
}
</script>

<style>
</style>
